import type { FaireBrandEntity } from "../../entity_types/brand";

export const catalog_brand_audreys_home_gift: FaireBrandEntity = {
  token: "catalog_brand_audreys_home_gift",
  type: "brand",
  name: "Audrey's Home & Gift",
  logoUrl:
    "https://cdn.faire.com/fastly/f8d35214384d0cddc7711e8e5047d8a681ec72ecb1c2c682d77eebd47512c376.jpeg?dpr=1&fit=crop&format=jpg&height=192&width=192",
  rating: 4.9,
  reviewCount: 707,
  location: "Lebanon, Pennsylvania",
  minimumOrderDollars: 250,
  isTopShop: true,
  productCount: 3596,
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "common-sets-db-backfill",
  },
};
